import simpleRestProvider from 'ra-data-simple-rest';

import httpClient from './httpClient';
import { API_URL } from '../api';

const dataProvider = simpleRestProvider(API_URL, httpClient);

export default dataProvider;
